import { useEffect } from 'react'

declare global {
  interface Window {
    __PRERENDER_READY__?: boolean
  }
}

/**
 * Signal to the Puppeteer prerender script that the page is fully rendered
 * and safe to snapshot. The script (`scripts/prerender.mjs`) polls for
 * `window.__PRERENDER_READY__ === true` before calling `page.content()`.
 *
 * Pages that need data before being snapshot-worthy (surah text + translation)
 * call `usePrerenderReady(dataReady)` and pass true once their fetches resolve.
 * In non-Puppeteer runs the flag is harmless — it's a global that no real
 * user code reads.
 */
export function usePrerenderReady(ready: boolean): void {
  useEffect(() => {
    if (ready && typeof window !== 'undefined') {
      window.__PRERENDER_READY__ = true
    }
  }, [ready])
}
